import * as React from 'react';

import { getUndergroundIcon } from '../../utils';
import { UndergroundIconWrapper } from '../UndergroundIconWrapper';
import { ELocationTypeId, type IUnderground, type IAddress, type IOffer } from 'shared/offer/types';

interface IUndergroundIconContainerProps {
  offer: IOffer;
  underground: IUnderground;
}

export const UndergroundIconContainer: React.FC<IUndergroundIconContainerProps> = props => {
  const { offer, underground } = props;

  const id = React.useMemo(() => {
    const { id } =
      (offer.geo && offer.geo.address.find(item => item.locationTypeId === ELocationTypeId.City)) || ({} as IAddress);

    return id;
  }, [offer.geo]);

  const color = React.useMemo(() => (underground && `#${underground.lineColor}`) || undefined, [underground]);

  const icon = React.useMemo(() => getUndergroundIcon({ underground, regionId: id }), [id, underground]);

  if (!underground) {
    return null;
  }

  return <UndergroundIconWrapper color={color}>{icon}</UndergroundIconWrapper>;
};
